import React from 'react';
import { Card, Grid, TextField, FormControl, Select, MenuItem, Typography } from '@mui/material';

const inputSx = {
  '& .MuiInputBase-root': { height: 56, borderRadius: 1.1 },
  '& .MuiInputBase-input': { py: 0, fontSize: 20 },
};

const selectSx = {
  height: 56,
  borderRadius: 1.1,
  '& .MuiSelect-select': {
    height: '56px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    py: 0,
    fontSize: 20,
  },
};

export default function ProductionInputs({ lot, setLot, batch, setBatch, shift, setShift, weight, setWeight, weightRequired = false, qty, setQty, qtyRequired = false, unit, refValue, setRefValue, noValue, setNoValue, refOptions = [], operator, setOperator, operatorOptions = [], disabled = false }) {
  return (
    <Card sx={{ width: '100%', p: { xs: 1.4, md: 1.75 }, mt: 0.2, borderRadius: 1.4, boxShadow: 'none', border: '1px solid #edf1f1' }}>
      <Grid container spacing={1.2}>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Lot</Typography>
          <TextField fullWidth required disabled={disabled} placeholder="" value={lot} onChange={(e) => setLot(e.target.value)} size="small" sx={inputSx} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Batch</Typography>
          <TextField fullWidth required disabled={disabled} placeholder="" value={batch} onChange={(e) => setBatch(e.target.value)} size="small" sx={inputSx} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Shift</Typography>
          <FormControl fullWidth>
            <Select value={shift} displayEmpty onChange={(e) => setShift(e.target.value)} disabled={disabled} size="small" sx={selectSx}>
              <MenuItem value="D">D</MenuItem>
              <MenuItem value="N">N</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Weight (kg)</Typography>
          <TextField fullWidth required={weightRequired} placeholder="" type="text" value={weight} onChange={(e) => { if (/^\d{0,3}(\.\d{0,2})?$/.test(e.target.value)) setWeight(e.target.value); }} size="small" disabled={disabled || !weightRequired} inputProps={{ inputMode: 'decimal', maxLength: 6, pattern: '[0-9]{1,3}(\\.[0-9]{1,2})?' }} sx={{ ...inputSx, backgroundColor: weightRequired ? '#fff' : '#f2f2f2' }} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Qty</Typography>
          <TextField fullWidth required={qtyRequired} placeholder="" type="text" value={qty} onChange={(e) => { if (/^\d{0,4}(\.\d{0,2})?$/.test(e.target.value)) setQty(e.target.value); }} size="small" disabled={disabled || !qtyRequired} inputProps={{ inputMode: 'decimal', pattern: '[0-9]{1,4}(\\.[0-9]{1,2})?' }} sx={{ ...inputSx, backgroundColor: qtyRequired ? '#fff' : '#f2f2f2' }} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Unit</Typography>
          <TextField fullWidth placeholder="" value={unit || ''} disabled size="small" sx={{ ...inputSx, backgroundColor: '#f2f2f2' }} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Ref.</Typography>
          <FormControl fullWidth>
            <Select value={refValue} displayEmpty onChange={(e) => setRefValue(e.target.value)} disabled={disabled} size="small" sx={selectSx}>
              <MenuItem value="">-</MenuItem>
              {refOptions.map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>No.</Typography>
          <TextField fullWidth placeholder="" value={noValue} onChange={(e) => { if (/^\d{0,3}$/.test(e.target.value)) setNoValue(e.target.value); }} disabled={disabled} inputProps={{ maxLength: 3, inputMode: 'numeric', pattern: '[0-9]{0,3}' }} size="small" sx={inputSx} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Operate</Typography>
          <FormControl fullWidth>
            <Select value={operator} displayEmpty onChange={(e) => setOperator(e.target.value)} disabled={disabled} size="small" sx={selectSx}>
              <MenuItem value="">-</MenuItem>
              {operatorOptions.map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Card>
  );
}

